import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class GetAiInsightsCategoriesRequest extends BaseServiceRequest {
  constructor() {
    super();
    super.addRequestUri("aiInsights/categories");
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }

  // getMessageName() {
  //   return "AiInsightsCategoriesResponseData";
  // }
}

export default GetAiInsightsCategoriesRequest;
